import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { LinkProps } from '@repo/ui/src/types/link';

interface Props {
  title?: string;
  postDescription?: string;
  darkMode?: boolean;
  className?: string;
  isAnimating?: boolean;
  link?: LinkProps;
}

const PostTimerBlock = ({
  title,
  postDescription,
  darkMode,
  className,
  isAnimating,
  link,
}: Props) => {
  return (
    <div
      className={classNames(
        'tw-z-101 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-transition-opacity tw-duration-1000 tw-ease-in-out tw-delay-[2s] tw-px-5',
        isAnimating ? 'tw-opacity-100' : 'tw-opacity-0 tw-pointer-events-none',
        className,
      )}
      data-testid="post-timer-block"
    >
      <div className={classNames(darkMode ? 'tw-text-white' : 'tw-text-gray-800')}>
        <h2 className="tra-text-web-heading-2 tw-transition-opacity">{title}</h2>
      </div>
      <hr className={classNames('tw-border-2 tw-w-10 tw-border-brand-300 tw-my-4')} />
      <p
        className={classNames(
          'tra-text-web-body-xl tw-max-w-[700px]',
          darkMode ? 'tw-text-white' : 'tw-text-gray-800',
        )}
      >
        {postDescription}
      </p>
      {link?.displayName && (
        <Button
          {...link}
          as={Anchor}
          className={classNames(
            'tw-mt-8 tw-px-6 tw-py-2 tw-rounded-md tw-transition-colors',
            darkMode
              ? 'tw-bg-orange-500 hover:tw-bg-orange-600 tw-text-white'
              : 'tw-bg-orange-500 hover:tw-bg-orange-600 tw-text-white',
          )}
        >
          {link.displayName}
        </Button>
      )}
    </div>
  );
};

export default PostTimerBlock;
